<template>
  <div >
    <img
        v-if="img"
        :alt="alt"
        id="logo"
        :src="img"
      >
      <img
        v-else
        :alt="alt"
        id="logo"
        src="@/assets/img/ds6.png"
      >
      <br><br>
      <a
        class="m-card-element-edition-image-btn m-card-element-edition-image-btn-products"
        href="#"
        @click.prevent="changeCardImage('inputImagen')"
      >
        {{label}}
      <i class="far fa-image"></i>
      </a>
      <input
        v-show="false"
        data-img-id="logo"
        name="imagen"
        id="inputImagen"
        ref="file"
        type="file"
        value=""
        @change="previewCardImage"
      >
    <ul style="list-style-type:none;">
      <li>
        <small class="font-weight-light">
          <i>{{ $t('aInputFileImagePrimary.logo.messages.extensions') }}</i>
        </small>
      </li>
      <li>
        <small class="font-weight-light">
          <i>{{ $t('aInputFileImagePrimary.logo.messages.dimensions') }}</i>
        </small>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AtomInputFileImagePrimary',

  props: {
    label: String,
    alt: String,
    messageErrorExtension: String,
    messageErrorFileSize: String
  },
  data () {
    return {
      isFileExtensionValid: true,
      isFileSizeValid: true,
      img: ''
    }
  },
  methods: {
    changeCardImage (inputId) {
      document.getElementById(inputId).click()
    },

    previewCardImage (event) {
      let input = event.target
      this.isFileExtensionValid = this.$utils.validateFileExtension(input.files[0].name, 'image')
      this.isFileSizeValid = this.$utils.validateFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        var reader = new FileReader()
        reader.onload = (e) => {
          document.getElementById(input.getAttribute('data-img-id')).src = e.target.result
          this.img = e.target.result
          this.$emit('changeLogo', this.img)
        }
        reader.readAsDataURL(input.files[0])
      }
    }
  }
}
</script>
